










import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

const Props = Vue.extend({
	props: {
		/** The width of the component */
		width: {
			type: String,
			default: '100px'
		},
		/** The height of the component */
		height: {
			type: String,
			default: '1rem'
		}
	}
});

const MixinsDeclaration = mixins(Props);

/**
 * HeaderLoading is a component that extends VSkeletonLoader
 * to provide a loader that you can size as needed
 */
@Component({
	inheritAttrs: false
})
export default class HeaderLoading extends MixinsDeclaration {}
